import { QuarterlyReport } from '../../types/reports';
import { ReportStatusCard } from '../common/ReportStatusCard';
import { mapReportStatus } from '../../utils/statusUtils';

interface QuarterlyReportCardProps {
  report: QuarterlyReport;
  onSubmit: (reportId: string) => void;
  onView: (reportId: string) => void;
  onUpdate: (reportId: string) => void;
}

export function QuarterlyReportCard({ report, onSubmit, onView, onUpdate }: Readonly<QuarterlyReportCardProps>) {
  return (
    <ReportStatusCard
      id={report.id}
      title={report.title}
      dueDate={report.dueDate}
      status={mapReportStatus(report.status, report.dueDate)}
      isInProgress={report.isInProgress}
      onSubmit={onSubmit}
      onView={onView}
      onUpdate={onUpdate}
    />
  );
} 
